import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';


import { BrandingAngularModule } from 'rev-portal/branding/BrandingAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { VbBtnPrimaryDirective } from 'rev-shared/ui/buttons/VbBtnPrimary.Directive';
import { VbBtnWhiteDirective } from 'rev-shared/ui/buttons/VbBtnWhite.Directive';
import { VbUiTextInputDirective } from 'rev-shared/ui/textInput/VbUiTextInput.Directive';

import { CssRulesAngularModule } from '../css/Css.AngularModule';
import { DateRangePickerComponent } from './DateRangePicker.Component';
import { VbUiDatePickerComponent } from './VbUiDatePicker.Component';
import { DatePickerStylesComponent } from './DatePickerStyles.Component';

const exports = [
	VbUiDatePickerComponent,
	DateRangePickerComponent
];

@NgModule({
	declarations: [
		...exports,
		DatePickerStylesComponent
	],
	exports,
	imports: [
		BrandingAngularModule,
		BsDatepickerModule,
		BsDropdownModule,
		CommonModule,
		CssRulesAngularModule,
		DirectivesAngularModule,
		FormsModule,
		TranslateModule,
		VbBtnPrimaryDirective,
		VbBtnWhiteDirective,
		VbUiTextInputDirective
	]
})
export class VbUiDatePickerModule {}
